import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static PATIENT_GENRE_ID = '87700497';
  static PRACTITIONER_GENRE_ID = '954016286';
  static targets = [
    'marketingContact',
    'marketingContactSelect',
    'advancedPermissions',
    'orderingParent',
    'orderingParentGroup',
  ];

  connect() {
    this.toggleAdvancedPermissions();
    this.initializeOrderingParentSelect();
  }

  disconnect() {
    if (this.orderingParentSelect) this.orderingParentSelect.destroy();
  }

  toggleMarketingContactField(e) {
    if (!this.hasMarketingContactTarget) return;

    this.marketingContactTarget.hidden =
      e.target.value === this.constructor.PATIENT_GENRE_ID;

    if (window.location.pathname.includes('/customers/new')) {
      if (e.target.value === this.constructor.PRACTITIONER_GENRE_ID) {
        this.marketingContactSelectTarget.value = 'true';
      } else {
        this.marketingContactSelectTarget.value = '';
      }
    }
  }

  toggleOrderingParentField(e) {
    if (!this.hasOrderingParentGroupTarget) return;

    this.orderingParentGroupTarget.hidden =
      e.target.value !== this.constructor.PRACTITIONER_GENRE_ID;
  }

  toggleAdvancedPermissions(event) {
    if (!this.hasAdvancedPermissionsTarget) return;

    const websiteAccessCheckbox = this.element.querySelector(
      'input[type="checkbox"][name*="website_access"]',
    );
    const visible = websiteAccessCheckbox
      ? websiteAccessCheckbox.checked
      : false;
    this.advancedPermissionsTarget.hidden = !visible;

    if (event && visible) {
      this.advancedPermissionsTarget
        .querySelectorAll('input[type="checkbox"]')
        .forEach((checkbox) => {
          checkbox.checked = true;
        });
    }
  }

  initializeOrderingParentSelect() {
    if (!this.hasOrderingParentTarget || this.orderingParentTarget.tomselect)
      return;

    this.orderingParentSelect = new TomSelect(this.orderingParentTarget, {
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      load: function (query, callback) {
        if (this.loading > 1) {
          callback();
          return;
        }

        const excludeId = this.input.dataset.excludeId || '';
        const settings = this.settings;
        const url = `/customers/list?exclude_id=${excludeId}`;
        fetch(url)
          .then((response) => response.json())
          .then((json) => {
            callback(json);
            settings.load = null;
          })
          .catch(() => {
            callback();
          });
      },
      render: {
        option: function (item, escape) {
          return `<div class="py-2 d-flex">
            <div class="mb-1">
              <span class="h5">
                ${escape(item.name)}
              </span>
            </div>
          </div>`;
        },
      },
    });
  }
}
